class WishlistButton extends HTMLElement {
  connectedCallback() {
    this.productId = this.dataset.productId;
    this.button = this.querySelector('.wishlist-btn__button');
    this.updateState();
    this.button.addEventListener('click', () => this.toggle());
  }

  getWishlist() {
    return JSON.parse(localStorage.getItem('wishlist') || '[]');
  }

  saveWishlist(list) {
    localStorage.setItem('wishlist', JSON.stringify(list));
    updateWishlistBubble();
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
  }

  isWishlisted() {
    return this.getWishlist().some(item => item.id === this.productId);
  }

  toggle() {
    let list = this.getWishlist();
    if (this.isWishlisted()) {
      list = list.filter(item => item.id !== this.productId);
    } else {
      list.push({
        id: this.productId,
        title: this.dataset.productTitle,
        url: this.dataset.productUrl,
        image: this.dataset.productImage,
        price: this.dataset.productPrice
      });
    }
    this.saveWishlist(list);
    this.updateState();
  }

  updateState() {
    const wishlisted = this.isWishlisted();
    this.button.setAttribute('aria-pressed', wishlisted);
    this.button.classList.toggle('wishlist-btn__button--active', wishlisted);
  }
}

customElements.define('wishlist-button', WishlistButton);

function updateWishlistBubble() {
  try {
    const raw = localStorage.getItem('wishlist');
    const wishlist = raw ? JSON.parse(raw) : [];
    const count = Array.isArray(wishlist) ? wishlist.length : 0;
    const bubble = document.getElementById('wishlist-bubble');
    if (!bubble) return;
    const countEl = bubble.querySelector('.wishlist-bubble__count');
    countEl.textContent = count > 99 ? '99+' : count > 0 ? String(count) : '';
    bubble.classList.toggle('wishlist-bubble--visible', count > 0);
  } catch (e) {}
}

// On page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateWishlistBubble);
} else {
  updateWishlistBubble();
}

// Listen for wishlist updates (e.g. from wishlist page remove button)
document.addEventListener('wishlist:updated', updateWishlistBubble);

// Catch changes from other tabs
window.addEventListener('storage', (e) => {
  if (e.key === 'wishlist') updateWishlistBubble();
});

// Re-apply bubble count after Shopify section re-renders
document.addEventListener('shopify:section:load', updateWishlistBubble);

document.addEventListener('wishlist:updated', updateWishlistBubble);
